// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1v308","pre":"App_pre__2fWbu"};